import { ICoordinates, IMeeting, TMeetingSetup, ceilMeasure, getShortUserName, hoursFormat } from "@utils";
import { format } from "date-fns";
import { MouseEvent } from "react";

export const getLeft = (
  minLeft: number, isDayCalendar: boolean, maxWidth: number, factor: number, layer: number
) =>
  // минимальное значение left прибавляется к:
  //  если это дневной календарь(isDayCalendar===true), то left будет только от краев в 10 процентов и + layer. Если это недельный календарь, то в factor приходит индекс дня недели, на который множится макс ширина. Потом прибавляется layer (чем больше layer, тем левее встреча) и плюс отступы от краев
  minLeft + (!isDayCalendar ? (maxWidth * factor) : 0) + layer * (10 * maxWidth / 100) + (5 * maxWidth / 100);

export const getDateTitle = (date: Date) => format(date, hoursFormat);

export const onClickMeeting = (
  e: MouseEvent<HTMLDivElement>, isMeetingPlaner: boolean, setPopupCoordinates: (coords: ICoordinates) => void, meeting: IMeeting, setMoreMeetingInformation: (meeting: IMeeting) => void
) => {
  e.preventDefault();
  if (!isMeetingPlaner && !meeting.draggingValues) {
    setPopupCoordinates({
      top: e.pageY,
      left: e.pageX,
      showTop: e.clientY > window.innerHeight / 2,
      showLeft: e.clientX > window.innerWidth / 2,
    });
    setMoreMeetingInformation(meeting);
  }
};

export const getActualMeeting = (meeting: IMeeting) => {
  const meetingSetup = {
    ...meeting.meetingSetup
  } ?? null;

  if (meetingSetup?.expDate && meeting?.draggingValues) {
    meetingSetup.expDate = meeting.draggingValues.endDate;
  }

  return meeting?.draggingValues
  ? {
    ...meeting,
    meetingSetup,
    startDate: meeting.draggingValues.startDate,
    endDate: meeting.draggingValues.endDate,
    layer: meeting.draggingValues.layer,
  }
  : meeting;
}
export const getTitle = (meeting: IMeeting, isShowInitiator: boolean) => {
  const actualMeeting = getActualMeeting(meeting);
  const dateTitle = `${getDateTitle(actualMeeting.startDate)}-${getDateTitle(actualMeeting.endDate)}`;
  const initiator = `${isShowInitiator ? `Организатор: ${getShortUserName(actualMeeting.initiator.fullName)}` : ''}`;
  return `${actualMeeting.meetingName}\n${dateTitle}\n${initiator}`;
};